<form class="form-horizontal mb-3" focusInvalidInput novalidate autocomplete="off" [formGroup]="radiusSearchForm">
    <div class="d-flex align-items-end justify-content-between flex-wrap gap-2">
        <div class="flex-grow-1 w-136" *ngIf="!hideOriginRadius">
            <app-select-control [formName]="radiusSearchForm" elementId="originRadius" [options]="radiusList"
                [multipleSelection]="false" [filter]="false" [showClear]="false" [isPrimeNgDropdown]="true"
                [isServerSideFilter]="false" styleClass="w-100" optionLabel="loadRadiusValue" optionValue="loadRadiusId"
                [control]="getControl('originRadius')" controlName="originRadius" [isShowLabel]="true"
                label="Origin Radius">
            </app-select-control>
        </div>

        <div class="flex-grow-1 w-136" *ngIf="!hideDestinationRadius">
            <app-select-control [formName]="radiusSearchForm" elementId="destinationRadius" [options]="radiusList"
                [multipleSelection]="false" [filter]="false" [showClear]="false" [isPrimeNgDropdown]="true"
                [isServerSideFilter]="false" styleClass="w-100" optionLabel="loadRadiusValue" optionValue="loadRadiusId"
                [control]="getControl('destinationRadius')" controlName="destinationRadius" [isShowLabel]="true"
                label="Destination Radius">
            </app-select-control>
        </div>
        <div class="d-flex align-items-center gap-2">
            <button type="button" class="btn btn-primary" (click)="onSearchClick()">Search</button>
            <button type="button" class="btn btn-outline-primary" (click)="clear()">Clear Filter</button>
        </div>
    </div>
</form>